(function () {
  function initSlider(root) {
    if (!root || root.dataset.primaveraSliderReady === 'true') return;

    const slides = Array.from(root.querySelectorAll('[data-primavera-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-primavera-dot]'));
    const prev = root.querySelector('[data-primavera-prev]');
    const next = root.querySelector('[data-primavera-next]');

    if (slides.length < 1) return;

    root.dataset.primaveraSliderReady = 'true';
    let current = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));

    function render(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === current;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === current;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

/* CUSTOM: hero mobile swipe and forced 3s autoplay */
const autoplay = 3000;
let autoplayTimer;
let touchStartX = 0;
let touchStartY = 0;
let isTouching = false;

function stopAutoplay() {
  if (autoplayTimer) window.clearInterval(autoplayTimer);
  autoplayTimer = null;
}

function startAutoplay() {
  stopAutoplay();
  if (slides.length > 1) autoplayTimer = window.setInterval(() => render(current + 1), autoplay);
}

function goTo(index) {
  render(index);
  startAutoplay();
}

function getTouchPoint(event) {
  return event.changedTouches ? event.changedTouches[0] : event.touches ? event.touches[0] : event;
}

function onTouchStart(event) {
  const point = getTouchPoint(event);
  if (!point) return;
  touchStartX = point.clientX;
  touchStartY = point.clientY;
  isTouching = true;
  stopAutoplay();
}

function onTouchEnd(event) {
  if (!isTouching) return;
  isTouching = false;
  const point = getTouchPoint(event);
  if (!point) {
    startAutoplay();
    return;
  }
  const deltaX = point.clientX - touchStartX;
  const deltaY = point.clientY - touchStartY;
  if (Math.abs(deltaX) > 42 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2) {
    render(current + (deltaX < 0 ? 1 : -1));
  }
  startAutoplay();
}

if (prev) prev.addEventListener('click', () => goTo(current - 1));
if (next) next.addEventListener('click', () => goTo(current + 1));
dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => goTo(dotIndex)));
root.addEventListener('touchstart', onTouchStart, { passive: true });
root.addEventListener('touchend', onTouchEnd, { passive: true });
root.addEventListener('touchcancel', startAutoplay, { passive: true });

startAutoplay();
render(current);
/* END CUSTOM: hero mobile swipe and forced 3s autoplay */
  }

  function initBook(root) {
    if (!root || root.dataset.primaveraBookReady === 'true') return;

    const stage = root.querySelector('.primavera-book__stage');
    const pages = Array.from(root.querySelectorAll('[data-primavera-book-page]'));
    const prev = root.querySelector('[data-primavera-book-prev]');
    const next = root.querySelector('[data-primavera-book-next]');

    if (!stage || pages.length < 1) return;

    root.dataset.primaveraBookReady = 'true';
    const lastPageIndex = pages.length - 1;
    const maxSpreadLeft = pages.length > 1 ? Math.max(1, lastPageIndex % 2 === 1 ? lastPageIndex : lastPageIndex - 1) : 0;
    let current = 0;
    let animationTimer;
    let isAnimating = false;

    function normalizeIndex(index) {
      if (pages.length <= 1) return 0;
      if (index <= 0) return 0;
      if (index > maxSpreadLeft) return 0;
      return index % 2 === 0 ? Math.max(1, index - 1) : index;
    }

    function getRightIndex(leftIndex) {
      if (leftIndex <= 0) return -1;
      return leftIndex + 1 < pages.length ? leftIndex + 1 : -1;
    }

    function clearTurnState() {
      window.clearTimeout(animationTimer);
      stage.querySelectorAll('[data-primavera-book-fade]').forEach((node) => node.remove());
      pages.forEach((page) => {
        page.classList.remove('is-turn-target-left', 'is-turn-target-right', 'is-turn-source');
      });
      root.classList.remove('is-fading');
    }

    function applyPageState(index) {
      current = normalizeIndex(index);
      const right = getRightIndex(current);
      const isCover = current === 0;
      const isSingle = !isCover && right === -1;

      root.classList.toggle('is-cover-view', isCover);
      root.classList.toggle('is-spread-view', !isCover && !isSingle);
      root.classList.toggle('is-single-view', isSingle);

      pages.forEach((page, pageIndex) => {
        const pageIsCover = isCover && pageIndex === 0;
        const pageIsLeft = !isCover && pageIndex === current;
        const pageIsRight = !isCover && pageIndex === right;
        const pageIsVisible = pageIsCover || pageIsLeft || pageIsRight;

        page.classList.toggle('is-cover', pageIsCover);
        page.classList.toggle('is-single', isSingle && pageIsLeft);
        page.classList.toggle('is-left', pageIsLeft && !isSingle);
        page.classList.toggle('is-right', pageIsRight);
        page.classList.toggle('is-active', pageIsVisible);
        page.classList.toggle('is-next', pageIsRight);
        page.classList.toggle('is-prev', false);
        page.setAttribute('aria-hidden', pageIsVisible ? 'false' : 'true');
      });
    }

    function setPageState(index) {
      clearTurnState();
      applyPageState(index);
      root.classList.remove('is-animating');
      isAnimating = false;
    }

    function cloneInner(pageIndex) {
      const source = pages[pageIndex] && pages[pageIndex].querySelector('.primavera-book__page-inner');
      return source ? source.cloneNode(true) : document.createElement('div');
    }

    function addFadePage(layer, pageIndex, className) {
      const page = document.createElement('div');
      page.className = `primavera-book__fade-page ${className}`;
      page.appendChild(cloneInner(pageIndex));
      layer.appendChild(page);
    }

    function addFadeLayer(index, className) {
      const layer = document.createElement('div');
      const right = getRightIndex(index);
      const isCover = index === 0;
      const isSingle = !isCover && right === -1;
      layer.className = `primavera-book__fade-layer ${className}`;
      layer.setAttribute('data-primavera-book-fade', '');

      if (isCover) {
        addFadePage(layer, 0, 'is-cover');
      } else {
        addFadePage(layer, index, isSingle ? 'is-single' : 'is-left');
        if (right !== -1) addFadePage(layer, right, 'is-right');
      }

      stage.appendChild(layer);
    }

    function fadeTo(target) {
      isAnimating = true;
      clearTurnState();
      addFadeLayer(current, 'is-from');
      root.classList.add('is-animating', 'is-fading');
      applyPageState(target);

      animationTimer = window.setTimeout(() => {
        stage.querySelectorAll('[data-primavera-book-fade]').forEach((node) => node.remove());
        root.classList.remove('is-fading', 'is-animating');
        isAnimating = false;
      }, 480);
    }

    function transitionTo(index, direction) {
      if (isAnimating) return;

      const target = normalizeIndex(index);
      const shouldAnimate = direction === 'next' || direction === 'prev';

      if (!shouldAnimate || target === current) {
        setPageState(target);
        return;
      }

      fadeTo(target);
    }

    root.primaveraSetBookPage = setPageState;

    if (prev) prev.addEventListener('click', () => transitionTo(current === 0 ? maxSpreadLeft : current - 2, 'prev'));
    if (next) next.addEventListener('click', () => transitionTo(current === 0 ? 1 : current + 2, 'next'));
    pages.forEach((page) => {
      page.addEventListener('click', () => {
        if (page.classList.contains('is-cover') || page.classList.contains('is-right')) {
          transitionTo(current === 0 ? 1 : current + 2, 'next');
        }
      });
    });

    setPageState(0);
  }

function initProductHook(root) {
  if (!root || root.dataset.primaveraProductHookReady === 'true') return;

  const variants = Array.from(root.querySelectorAll('[data-primavera-product-variant]'));
  const price = root.querySelector('[data-primavera-product-price]');
  const cityLabel = root.querySelector('[data-primavera-product-city]');
  const checkoutLink = root.querySelector('[data-primavera-product-checkout]');
  const detailLink = root.querySelector('[data-primavera-product-detail]');
  const quantityInput = root.querySelector('[data-primavera-product-qty]');
  const quantityMinus = root.querySelector('[data-primavera-product-qty-minus]');
  const quantityPlus = root.querySelector('[data-primavera-product-qty-plus]');
  const section = root.closest('[data-section-type="primavera-product-comparison"]');
  const book = section ? section.querySelector('[data-primavera-book]') : null;
  const bookCover = section ? section.querySelector('[data-primavera-book-cover]') : null;

  if (variants.length < 1) return;

  root.dataset.primaveraProductHookReady = 'true';
  let selectedVariant = null;

  function getQuantity() {
    if (!quantityInput) return 1;

    const quantity = Number.parseInt(quantityInput.value, 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function setQuantity(quantity) {
    if (!quantityInput) return;
    quantityInput.value = Math.max(1, quantity);
    syncCheckoutLink();
  }

  function getCheckoutUrl(button) {
    if (!button) return '#';
    if (button.dataset.variantId) {
      const routes = window.FoxThemeSettings && window.FoxThemeSettings.routes;
      const cartUrl = routes && routes.cart_url ? routes.cart_url : '/cart';
      return `${cartUrl}/${button.dataset.variantId}:${getQuantity()}`;
    }
    return button.dataset.variantCheckoutUrl || '#';
  }

  function syncCheckoutLink() {
    if (checkoutLink && selectedVariant) {
      checkoutLink.setAttribute('href', getCheckoutUrl(selectedVariant));
    }
  }

  function updateDisplayedPrice(currentPrice, comparePrice) {
    if (!price || !currentPrice) return;
    const priceWrapper = price.querySelector('[data-primavera-price]');
    const currentNode = price.querySelector('[data-primavera-current-price]');
    const compareNode = price.querySelector('[data-primavera-compare-price]');

    if (!currentNode) {
      price.textContent = currentPrice;
      return;
    }

    currentNode.textContent = currentPrice;
    const hasCompare = Boolean(comparePrice);
    if (compareNode) {
      compareNode.textContent = comparePrice || '';
      compareNode.hidden = !hasCompare;
    }
    if (priceWrapper) priceWrapper.classList.toggle('is-on-sale', hasCompare);
  }

  function updateBookCover(button) {

    if (!bookCover || !button) return;

    const src = button.dataset.variantCoverAgenda || bookCover.dataset.defaultCoverSrc || '';
    const alt = button.dataset.variantCoverAgendaAlt || bookCover.dataset.defaultCoverAlt || '';
    const sizes = bookCover.dataset.defaultCoverSizes || '(min-width: 750px) 58vw, 100vw';
    const placeholder = bookCover.querySelector('.primavera-placeholder__label');
    let image = bookCover.querySelector('img');

    if (!src) {
      if (image) image.hidden = true;
      if (placeholder) placeholder.hidden = false;
      return;
    }

    if (!image) {
      image = document.createElement('img');
      image.loading = 'lazy';
      image.decoding = 'async';
      bookCover.prepend(image);
    }

    image.hidden = false;
    image.removeAttribute('srcset');
    image.setAttribute('sizes', sizes);
    image.setAttribute('alt', alt);
    if (image.getAttribute('src') !== src) image.setAttribute('src', src);
    if (placeholder) placeholder.hidden = true;
  }

  function selectVariant(button) {
    if (!button || button.disabled) return;

    selectedVariant = button;

    variants.forEach((variant) => {
      const isSelected = variant === button;
      variant.classList.toggle('is-selected', isSelected);
      variant.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    updateDisplayedPrice(button.dataset.variantPrice, button.dataset.variantComparePrice);

    if (cityLabel) {
      cityLabel.textContent = button.dataset.variantCity || '';
      cityLabel.style.setProperty('--pv-selected-city-color', button.dataset.variantCityColor || 'var(--pv-brown)');
    }

    if (detailLink && button.dataset.variantUrl) {
      detailLink.setAttribute('href', button.dataset.variantUrl);
    }

    updateBookCover(button);
    if (book && typeof book.primaveraSetBookPage === 'function') {
      book.primaveraSetBookPage(0);
    }
    syncCheckoutLink();
  }

  variants.forEach((button) => {
    button.addEventListener('click', () => selectVariant(button));
  });

  if (quantityMinus) {
    quantityMinus.addEventListener('click', () => setQuantity(getQuantity() - 1));
  }

  if (quantityPlus) {
    quantityPlus.addEventListener('click', () => setQuantity(getQuantity() + 1));
  }

  if (quantityInput) {
    quantityInput.addEventListener('change', () => setQuantity(getQuantity()));
  }

  selectVariant(root.querySelector('[data-primavera-product-variant].is-selected') || variants[0]);
}

function initKit(card) {
  if (!card || card.dataset.primaveraKitReady === 'true') return;

  const addButton = card.querySelector('[data-primavera-kit-add]');
  const products = Array.from(card.querySelectorAll('[data-primavera-kit-product]'));
  const quantityInput = card.querySelector('[data-primavera-kit-qty]');
  const quantityMinus = card.querySelector('[data-primavera-kit-qty-minus]');
  const quantityPlus = card.querySelector('[data-primavera-kit-qty-plus]');

  if (products.length < 1) return;

  card.dataset.primaveraKitReady = 'true';

  function parseVariants(product) {
    if (product._primaveraVariants) return product._primaveraVariants;

    const source = product.querySelector('[data-primavera-kit-variants]');
    if (!source) return [];

    try {
      product._primaveraVariants = JSON.parse(source.textContent || '[]');
    } catch (error) {
      console.error(error);
      product._primaveraVariants = [];
    }

    return product._primaveraVariants;
  }

  function getQuantity() {
    if (!quantityInput) return 1;

    const quantity = Number.parseInt(quantityInput.value, 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function setQuantity(quantity) {
    if (!quantityInput) return;
    quantityInput.value = Math.max(1, quantity);
  }

  function getSelections(product) {
    const selections = {};

    product.querySelectorAll('[data-primavera-kit-option]').forEach((select) => {
      if (select.value) selections[select.dataset.optionPosition] = select.value;
    });

    const selectedColor = product.querySelector('[data-primavera-kit-color].is-selected:not(:disabled)');
    if (selectedColor) {
      selections[selectedColor.dataset.optionPosition || '1'] = selectedColor.dataset.optionValue;
    }

    return selections;
  }

  function variantMatches(variant, selections) {
    return Object.keys(selections).every((position) => {
      const optionIndex = Number.parseInt(position, 10) - 1;
      return variant.options && variant.options[optionIndex] === selections[position];
    });
  }

  function hasAvailableVariant(variants, selections) {
    return variants.some((variant) => variant.available && variantMatches(variant, selections));
  }

  function syncColorButtons(product, variants) {
    const buttons = Array.from(product.querySelectorAll('[data-primavera-kit-color]'));
    if (buttons.length < 1) return;

    const baseSelections = getSelections(product);
    let selectedButton = buttons.find((button) => button.classList.contains('is-selected'));

    buttons.forEach((button) => {
      const position = button.dataset.optionPosition || '1';
      const selections = { ...baseSelections, [position]: button.dataset.optionValue };
      const isAvailable = hasAvailableVariant(variants, selections);

      button.disabled = !isAvailable;
      button.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');

      if (!isAvailable && button.classList.contains('is-selected')) {
        button.classList.remove('is-selected');
        button.setAttribute('aria-checked', 'false');
        selectedButton = null;
      }
    });

    if (!selectedButton || selectedButton.disabled) {
      selectedButton = buttons.find((button) => !button.disabled) || buttons[0];
    }

    buttons.forEach((button) => {
      const isSelected = button === selectedButton && !button.disabled;
      button.classList.toggle('is-selected', isSelected);
      button.setAttribute('aria-checked', isSelected ? 'true' : 'false');
    });
  }

  function findVariant(product, variants) {
    const selections = getSelections(product);
    return (
      variants.find((variant) => variant.available && variantMatches(variant, selections)) ||
      variants.find((variant) => variant.available) ||
      variants[0] ||
      null
    );
  }

  function updatePreview(product, variant) {
    if (!variant) return;

    const role = product.dataset.kitRole;
    const previewProduct = card.querySelector(`[data-primavera-kit-preview-product][data-kit-role="${role}"]`);
    if (!previewProduct) return;

    const previewImage = previewProduct.querySelector('.primavera-kit__preview-img');
    const previewVariant = previewProduct.querySelector('[data-primavera-kit-preview-variant]');
    const title = variant.title || product.dataset.productTitle || '';

    if (previewImage && variant.image) {
      previewImage.src = variant.image;
      previewImage.srcset = variant.srcset || '';
      previewImage.alt = title;
    }

    if (previewVariant) {
      previewVariant.textContent = title;
    }

    if (variant.color) {
      previewProduct.style.setProperty('--pv-kit-preview-accent', variant.color);
    }
  }

  function syncProduct(product, revealPreview = false) {
    const variants = parseVariants(product);
    if (variants.length < 1) return;

    syncColorButtons(product, variants);
    const selectedVariant = findVariant(product, variants);
    if (!selectedVariant) return;

    product.dataset.selectedVariantId = selectedVariant.id;
    product.dataset.selectedVariantTitle = selectedVariant.title || '';
    updatePreview(product, selectedVariant);

    if (revealPreview) {
      card.classList.add('is-configuring');
    }
  }

  function getSelectedItems() {
    const quantity = getQuantity();

    return products
      .map((product) => {
        const id = product.dataset.selectedVariantId;
        if (!id) return null;

        return { id, quantity };
      })
      .filter(Boolean);
  }

  function setButtonState(isLoading, message) {
    if (!addButton) return;

    if (!addButton.dataset.defaultText) {
      addButton.dataset.defaultText = addButton.textContent.trim();
    }

    addButton.disabled = isLoading;
    addButton.classList.toggle('is-loading', isLoading);
    addButton.textContent = message || addButton.dataset.defaultText;
  }

  async function addKit() {
    if (!addButton || addButton.disabled) return;

    const items = getSelectedItems();
    if (items.length < 1) return;

    const formData = new FormData();
    items.forEach((item, index) => {
      formData.append(`items[${index}][id]`, item.id);
      formData.append(`items[${index}][quantity]`, item.quantity);
    });

    let sectionToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', {
        bubbles: true,
        detail: { sections: sectionToBundle },
      })
    );

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      sectionToBundle = [
        ...sectionToBundle,
        ...cartDrawer.getSectionsToRender().map((section) => section.id),
      ];
    }

    if (sectionToBundle.length > 0) {
      formData.append('sections', sectionToBundle);
      formData.append('sections_url', window.location.pathname);
    }

    const routes = window.FoxThemeSettings && window.FoxThemeSettings.routes;
    const cartAddUrl = routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add.js';

    setButtonState(true);

    try {
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });
      const state = await response.json();

      if (state.status) {
        throw new Error(state.description || state.message);
      }

      const pubSubEvents = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;

      if (window.FoxThemeEvents && pubSubEvents && pubSubEvents.cartUpdate && state.sections) {
        window.FoxThemeEvents.emit(pubSubEvents.cartUpdate, state);
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      }

      if (window.FoxThemeCartHelpers && typeof window.FoxThemeCartHelpers.getState === 'function') {
        window.FoxThemeCartHelpers.getState().then((cart) => {
          if (cart && typeof window.FoxThemeCartHelpers.updateCartCount === 'function') {
            window.FoxThemeCartHelpers.updateCartCount(cart.item_count);
          }
        });
      }

      setButtonState(false, 'AGGIUNTO');
      window.setTimeout(() => setButtonState(false), 1800);
    } catch (error) {
      console.error(error);
      setButtonState(false, 'NON DISPONIBILE');
      window.setTimeout(() => setButtonState(false), 2200);
    }
  }

  products.forEach((product) => {
    const firstColor = product.querySelector('[data-primavera-kit-color].is-selected') || product.querySelector('[data-primavera-kit-color]');
    if (firstColor) {
      firstColor.classList.add('is-selected');
      firstColor.setAttribute('aria-checked', 'true');
    }

    product.querySelectorAll('[data-primavera-kit-color]').forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;

        const group = product.querySelectorAll(`[data-primavera-kit-color][data-option-position="${button.dataset.optionPosition || '1'}"]`);
        group.forEach((item) => {
          const isSelected = item === button;
          item.classList.toggle('is-selected', isSelected);
          item.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        });

        syncProduct(product, true);
      });
    });

    product.querySelectorAll('[data-primavera-kit-option]').forEach((select) => {
      select.addEventListener('change', () => syncProduct(product, true));
    });

    syncProduct(product);
  });

  if (quantityMinus) {
    quantityMinus.addEventListener('click', () => setQuantity(getQuantity() - 1));
  }

  if (quantityPlus) {
    quantityPlus.addEventListener('click', () => setQuantity(getQuantity() + 1));
  }

  if (quantityInput) {
    quantityInput.addEventListener('change', () => setQuantity(getQuantity()));
  }

  if (addButton) addButton.addEventListener('click', addKit);
}

  function initKitMediaSlider(root) {
    if (!root || root.dataset.primaveraKitMediaReady === 'true') return;

    const track = root.querySelector('[data-primavera-kit-media-track]');
    const slides = track ? Array.from(track.querySelectorAll('[data-primavera-kit-media-slide]')) : [];
    const prev = root.querySelector('[data-primavera-kit-media-prev]');
    const next = root.querySelector('[data-primavera-kit-media-next]');
    const dots = Array.from(root.querySelectorAll('[data-primavera-kit-media-dot]'));

    if (!track || slides.length < 1) return;

    root.dataset.primaveraKitMediaReady = 'true';
    let current = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));

    function pauseInactiveVideos() {
      slides.forEach((slide, slideIndex) => {
        if (slideIndex === current) return;

        slide.querySelectorAll('video').forEach((video) => {
          if (typeof video.pause === 'function') video.pause();
        });
      });
    }

    function playActiveVideos() {
      const activeSlide = slides[current];
      if (!activeSlide) return;

      activeSlide.querySelectorAll('video').forEach((video) => {
        video.muted = true;
        video.defaultMuted = true;
        video.autoplay = true;
        video.loop = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('loop', '');

        if (typeof video.play === 'function') {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        }
      });
    }

    function render(index, shouldScroll) {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === current));
      pauseInactiveVideos();
      playActiveVideos();

      if (shouldScroll !== false) {
        track.scrollTo({ left: current * track.clientWidth, behavior: 'smooth' });
        window.clearTimeout(root.primaveraKitMediaPlayTimer);
        root.primaveraKitMediaPlayTimer = window.setTimeout(playActiveVideos, 380);
      }
    }

    function getScrollIndex() {
      return track.clientWidth > 0 ? Math.round(track.scrollLeft / track.clientWidth) : 0;
    }

    if (prev) prev.addEventListener('click', () => render(current - 1));
    if (next) next.addEventListener('click', () => render(current + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => render(index)));
    track.addEventListener(
      'scroll',
      () => {
        window.clearTimeout(root.primaveraKitMediaScrollTimer);
        root.primaveraKitMediaScrollTimer = window.setTimeout(() => render(getScrollIndex(), false), 90);
      },
      { passive: true }
    );

    render(current, false);
  }

  function initVacationCarousel(root) {
    if (!root || root.dataset.primaveraVacanzaReady === 'true') return;

    const track = root.querySelector('[data-primavera-vacanza-track]');
    const prev = root.querySelector('[data-primavera-vacanza-prev]');
    const next = root.querySelector('[data-primavera-vacanza-next]');
    const cards = track ? Array.from(track.querySelectorAll('.primavera-vacanza-card')) : [];

    if (!track || cards.length < 1) return;

    root.dataset.primaveraVacanzaReady = 'true';

    function getStep() {
      const firstCard = cards[0];
      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap || 0) || 0;
      return firstCard.getBoundingClientRect().width + gap;
    }

    function getIndex() {
      const step = getStep();
      return step > 0 ? Math.round(track.scrollLeft / step) : 0;
    }

    function scrollToIndex(index) {
      const maxIndex = cards.length - 1;
      const nextIndex = (index + cards.length) % cards.length;
      const boundedIndex = Math.max(0, Math.min(maxIndex, nextIndex));
      track.scrollTo({ left: boundedIndex * getStep(), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', () => scrollToIndex(getIndex() - 1));
    if (next) next.addEventListener('click', () => scrollToIndex(getIndex() + 1));
  }

  function init(scope) {
    const parent = scope || document;
    parent.querySelectorAll('[data-primavera-slider]').forEach(initSlider);
    parent.querySelectorAll('[data-primavera-book]').forEach(initBook);
    parent.querySelectorAll('[data-primavera-vacanza]').forEach(initVacationCarousel);
    parent.querySelectorAll('[data-primavera-kit-media]').forEach(initKitMediaSlider);
    parent.querySelectorAll('[data-primavera-product-hook]').forEach(initProductHook);
    parent.querySelectorAll('[data-primavera-kit-card]').forEach(initKit);
  }

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
